import { render } from "./InputFile.vue?vue&type=template&id=7c60f441&scoped=true&ts=true"
import script from "./InputFile.vue?vue&type=script&lang=ts"
export * from "./InputFile.vue?vue&type=script&lang=ts"

import "./InputFile.vue?vue&type=style&index=0&id=7c60f441&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c60f441"]])

export default __exports__